import useSWR, { SWRConfiguration } from "swr";
import { Location } from "../models";
import fetcher from "./fetcher";
import usePermissions from "./usePermissions";

interface UseLocationsProps {
    companyId?: string;
    options?: SWRConfiguration;
}

export const useLocations = ({
    companyId,
    options = {},
}: UseLocationsProps) => {
    const { mutatePermissions } = usePermissions();

    const { data, error, isLoading, mutate } = useSWR(
        companyId
            ? `/api/space-management/v1/companies/${companyId}/locations`
            : null,
        fetcher,
        {
            fallbackData: [],
            ...options,
        }
    );

    const handleMutate = () => {
        mutatePermissions();
        mutate();
    };

    return {
        locations: data as Array<Location>,
        isLoadingLocations: isLoading,
        isError: error,
        mutateLocations: handleMutate,
    };
};
